import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { LOGO_URL, PRODUCT_NAME, STORE_URL } from '../constants/site';
const NAV_LINKS = [{
  label: 'Features',
  href: '/#features'
}, {
  label: 'How it works',
  href: '/#how'
}, {
  label: 'Privacy',
  href: '/#privacy'
}, {
  label: 'FAQ',
  href: '/#faq'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  return <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/80 backdrop-blur-md" data-id="element-154">
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6" data-id="element-155">
        <Link to="/" className="flex items-center gap-2" aria-label={`${PRODUCT_NAME} home`} data-id="element-156">
          <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-white" data-id="element-157">
            <img src={LOGO_URL} alt="" className="h-9 w-9 object-contain" data-id="element-158" />
          </span>
          <span className="text-2xl font-extrabold tracking-tight text-slate-900" data-id="element-159">
            {PRODUCT_NAME}
          </span>
        </Link>

        <div className="hidden items-center gap-8 md:flex" data-id="element-160">
          {pathname === '/' && NAV_LINKS.map(l => <a key={l.href} href={l.href} className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-900" data-id="element-161">
                {l.label}
              </a>)}
          <a href={STORE_URL} target="_blank" rel="noopener noreferrer" className="rounded-full bg-[#1d9bf0] px-5 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[#1a8cd8]" data-id="element-162">
            Add to Chrome
          </a>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-slate-700 hover:bg-slate-100 md:hidden" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} data-id="element-163">
          {open ? <CloseIcon data-id="element-164" /> : <MenuIcon data-id="element-165" />}
        </button>
      </nav>

      <AnimatePresence data-id="element-166">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden border-t border-slate-200 bg-white md:hidden" data-id="element-167">
            <div className="flex flex-col gap-1 px-4 py-3" data-id="element-168">
              {pathname === '/' && NAV_LINKS.map(l => <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="rounded-lg px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100" data-id="element-169">
                    {l.label}
                  </a>)}
              <a href={STORE_URL} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className="mt-1 rounded-full bg-[#1d9bf0] px-5 py-2 text-center text-sm font-semibold text-white" data-id="element-170">
                Add to Chrome
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}